import { auth, useAuth } from "@/lib";
import { UserButton } from "@clerk/clerk-react";
import { useNavigate } from "@tanstack/react-router";
import { EllipsisVerticalIcon, LogOutIcon, BadgeCheck, Bell, ChevronsUpDown, ChevronUp, CreditCard, LogOut, Sparkles, UserCircle } from "lucide-react";

import {
	Avatar,
	AvatarFallback,
	AvatarImage,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
	SidebarFooter as SidebarFooterMain,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "shadcn-ui";

export const SidebarFooter = () => {
	// const { user, signOut } = useAuth()
	// const { isMobile } = useSidebar()


	// const navigate = useNavigate()

	return <SidebarFooterMain />

	return (
		<SidebarFooterMain>
			<SidebarMenu>
				<SidebarMenuItem>
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<SidebarMenuButton
								size="lg"
								className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
								tooltip={`${user.fullName} - ${user.email}`}
							>
								<Avatar className="h-8 w-8 rounded-lg shrink-0">
									<AvatarImage src={user.image} alt={user.fullName} />
									<AvatarFallback className="rounded-lg">{user.firstName?.slice(0, 1)?.toUpperCase()}{user.lastName?.slice(0, 1)?.toUpperCase()}</AvatarFallback>
								</Avatar>
								<div className="grid flex-1 text-left text-sm leading-tight">
									<span className="truncate font-semibold">{user.fullName}</span>
									<span className="truncate text-xs text-sidebar-foreground/70">
										{user.email}
									</span>
								</div>
								<EllipsisVerticalIcon className="ml-auto size-4 shrink-0" />
							</SidebarMenuButton>
						</DropdownMenuTrigger>
						<DropdownMenuContent
							className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
							side={isMobile ? "bottom" : "right"}
							align="end"
							sideOffset={4}
						>
							<DropdownMenuLabel className="p-0 font-normal">
								<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
									<Avatar className="h-8 w-8 rounded-lg">
										<AvatarImage src={user.image} alt={user.fullName} />
										<AvatarFallback className="rounded-lg">{user.firstName?.slice(0, 1)?.toUpperCase()}{user.lastName?.slice(0, 1)?.toUpperCase()}</AvatarFallback>
									</Avatar>
									<div className="grid flex-1 text-left text-sm leading-tight">
										<span className="truncate font-medium">{user.fullName}</span>
										<span className="truncate text-xs text-sidebar-foreground/70">
											{user.displayUsername?.toUpperCase()}
										</span>

									</div>
								</div>
							</DropdownMenuLabel>
							<DropdownMenuSeparator />
							<DropdownMenuGroup>
								<DropdownMenuItem onClick={() => navigate({
									to: "/account"
								})}>
									<UserCircle className="size-4 mr-2" />
									Account
								</DropdownMenuItem>
							</DropdownMenuGroup>
							<DropdownMenuSeparator />
							<DropdownMenuItem onClick={() => {
								signOut()
								navigate({
									to: "/login",
									replace: true
								})
							}}>
								<LogOutIcon className="size-4 mr-2" />
								Log out
							</DropdownMenuItem>
						</DropdownMenuContent>
					</DropdownMenu>
				</SidebarMenuItem>
			</SidebarMenu>
		</SidebarFooterMain>
	);
};







export function NavUser() {
	const { data } = auth.useSession()
	const navigate = useNavigate()
	const user = data?.user
	const { isMobile } = useSidebar()

	if (!user) return null

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<SidebarMenuButton
							size="lg"
							className="group-data-[state=open]:p-0 data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
							tooltip={`${user.fullName} - ${user.email}`}
							variant="footer"
						>
							<Avatar className="h-8 w-8 rounded-lg shrink-0">
								<AvatarImage src={user.image} alt={user.fullName} />
								<AvatarFallback className="rounded-lg">{user.firstName?.slice(0, 1)?.toUpperCase()}{user.lastName?.slice(0, 1)?.toUpperCase()}</AvatarFallback>
							</Avatar>
							<div className="grid flex-1 text-left text-sm leading-tight">
								<span className="truncate font-semibold">{user.fullName}</span>
								<span className="truncate text-xs text-sidebar-foreground/70">
									{user.email}
								</span>
							</div>
							<EllipsisVerticalIcon className="ml-auto size-4" />
						</SidebarMenuButton>
					</DropdownMenuTrigger>
					<DropdownMenuContent
						className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
						side={isMobile ? "bottom" : "right"}
						align="end"
						sideOffset={4}
					>
						<DropdownMenuLabel className="p-0 font-normal">
							<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
								<Avatar className="h-8 w-8 rounded-lg">
									<AvatarImage src={user.image} alt={user.fullName} />
									<AvatarFallback className="rounded-lg">{user.firstName?.slice(0, 1)?.toUpperCase()}{user.lastName?.slice(0, 1)?.toUpperCase()}</AvatarFallback>
								</Avatar>
								<div className="grid flex-1 text-left text-sm leading-tight">
									<span className="truncate font-medium">{user.fullName}</span>
									<span className="truncate text-xs text-sidebar-foreground/70">
										{user.displayUsername?.toUpperCase()}
									</span>

								</div>
							</div>
						</DropdownMenuLabel>
						<DropdownMenuSeparator />
						<DropdownMenuGroup>
							<DropdownMenuItem onClick={() => navigate({
								to: "/account"
							})}>
								<UserCircle className="size-4 mr-2" />
								Account
							</DropdownMenuItem>
						</DropdownMenuGroup>
						<DropdownMenuSeparator />
						<DropdownMenuItem onClick={() => {
							auth.signOut()
							navigate({
								to: "/login",
								replace: true
							})
						}}>
							<LogOutIcon className="size-4 mr-2" />
							Log out
						</DropdownMenuItem>
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	)
}
